import { CellContext } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { FolderPermissionResponse } from '../../../../api/types.gen';
import { CreatePermissionLevel } from './PermissionEnums';
import { PermissionTableFeatures } from './permissionTableFeatures';

interface CreatePermissionCellProps {
  cellContext: CellContext<PermissionTableFeatures, FolderPermissionResponse, CreatePermissionLevel>;
}

export function CreatePermissionCell({ cellContext }: CreatePermissionCellProps) {
  const { t } = useTranslation('', { keyPrefix: 'permissions' });
  const value = cellContext.getValue();

  switch (value) {
    case CreatePermissionLevel.CreateItemsAndSubFolders:
      return <>{t('createPermissionsItemsSubfolders')}</>;
    case CreatePermissionLevel.CreateItems:
      return <>{t('createPermissionsItems')}</>;
    case CreatePermissionLevel.CreateSubFolders:
      return <>{t('createPermissionsSubfolders')}</>;
    default:
      return <>{t('createPermissionsNone')}</>;
  }
}
